// extracted by mini-css-extract-plugin
export default {"breakdown":"SummaryFinance-module--breakdown--b02fa","heading":"SummaryFinance-module--heading--790b6","waived":"SummaryFinance-module--waived--e8429"};